module.exports = __webpack_public_path__ + "static/media/logo-bbc-1xtra-2.48c957fd.svg";